/**
 * IconPill — Kompakter Icon-Toggle im STXThemeToggle-Style.
 *
 * Anwendungsfälle:
 * - Light ⟷ Dark
 * - Grid ⟷ List View
 * - Filter On ⟷ Off
 * - Sound On ⟷ Off
 *
 * Der Toggle rendert immer Icon + optional Label.
 * `activeIcon`/`activeLabel` überschreibt beim aktiven Zustand.
 */
export default function IconPill({
  active = false,
  disabled = false,
  variant = "neutral",
  icon,
  activeIcon,
  label,
  activeLabel,
  onClick,
  testId,
  ariaLabel,
  className = "",
}) {
  const VARIANTS = {
    neutral: {
      active:   "border-[#0A0A0A] text-[#0A0A0A] bg-[#F5F5F5]",
      inactive: "border-[#E5E5E5] text-[#666] hover:border-[#0A0A0A] hover:text-[#0A0A0A]",
    },
    stx: {
      active:   "border-stx-accent text-stx-accent bg-stx-accent-soft",
      inactive: "border-stx-border text-stx-text-muted hover:text-stx-accent hover:border-stx-accent",
    },
    ghost: {
      active:   "border-transparent bg-white/10 text-white",
      inactive: "border-transparent text-white/70 hover:bg-white/10 hover:text-white",
    },
  };
  const v = VARIANTS[variant] || VARIANTS.neutral;
  const cls = active ? v.active : v.inactive;
  const IconEl = active ? (activeIcon || icon) : icon;
  const LabelText = active ? (activeLabel != null ? activeLabel : label) : label;
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      aria-pressed={active}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      data-active={active ? "true" : "false"}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-full border transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${cls} ${className}`}
    >
      {IconEl}
      {LabelText != null && (
        <span className="text-[10px] uppercase tracking-wider font-semibold">
          {LabelText}
        </span>
      )}
    </button>
  );
}
